import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import moment from 'moment';
import { HourStatus } from '@scentregroup/shared/graphql';
import { formatTimes, formatHumanDate } from '../date-format-helpers';
import { HOURS_BANNER_DINELATE } from '../../constants';

const getDescription = (description, closed, isLateNight) => ({
  get description() {
    if (description) {
      return description;
    } else if (!description && !closed && isLateNight) {
      return HOURS_BANNER_DINELATE;
    } else {
      return '';
    }
  },

  isColored: Boolean(description)
});

const groupOvernightAndMultiple = function groupOvernightAndMultiple(tradingHours) {
  const result = [];
  let prevTradingHour = {
    hourStatus: null,
    date: '1900-01-01'
  };
  tradingHours.forEach(tradingHour => {
    const bothHaveStatus = status => [prevTradingHour, tradingHour].every(hour => hour.hourStatus === status);

    const isSameDate = moment(prevTradingHour.date).isSame(moment(tradingHour.date));
    const isConsecutiveDate = moment(prevTradingHour.date).add(1, 'day').isSame(moment(tradingHour.date));
    const isMultipleGroup = bothHaveStatus(HourStatus.Multiple) && isSameDate;
    const isOvernightGroup = bothHaveStatus(HourStatus.Overnight) && isConsecutiveDate;

    if (isMultipleGroup || isOvernightGroup) {
      result[result.length - 1].push(tradingHour);
    } else {
      result.push([tradingHour]);
    }

    prevTradingHour = tradingHour;
  });
  return result;
};

const extractHoursFromGroup = function extractHoursFromGroup(group) {
  const showTimes = tradingHour => // The hyphen character "-" is an en dash (alt + "-")
  "".concat(tradingHour.openingTime, " \u2013 ").concat(tradingHour.closingTime);

  const firstInGroup = group[0];

  if (firstInGroup.hourStatus === HourStatus.Closed) {
    return ['Closed'];
  } else if ([HourStatus.Normal, HourStatus.Multiple].includes(firstInGroup.hourStatus)) {
    return group.map(showTimes);
  } else if (firstInGroup.hourStatus === HourStatus.Overnight) {
    return [// The hyphen character "-" is an en dash (alt + "-")
    "".concat(firstInGroup.openingTime, " \u2013 ").concat(group[1].closingTime, " (").concat(moment(group[1].date).format('ddd'), ")")];
  } else {
    return [''];
  }
};

const parseGroupedHours = function parseGroupedHours(groupedTradingHours, centreTimeZone, isLateNight) {
  return groupedTradingHours.map(group => ({
    day: formatHumanDate(moment.tz(group[0].date, centreTimeZone), {
      timeZone: centreTimeZone,
      includeMonth: true
    }),
    text: getDescription(group[0].description, group[0].isClosed, isLateNight),
    hours: extractHoursFromGroup(group),
    status: group[0].hourStatus
  }));
};

const ensureDefaults = tradingHours => tradingHours.map(tradingHourDay => _objectSpread(_objectSpread({}, tradingHourDay), {}, {
  description: tradingHourDay.description || '',
  hourStatus: tradingHourDay.hourStatus || HourStatus.Normal
}));

export const parseOpeningHours = function parseOpeningHours(tradingHours, centreTimeZone, centreFeatures) {
  const isLateNight = (centreFeatures || []).includes('Late Night Dining');
  const tradingHoursWithDefaults = ensureDefaults(tradingHours);
  const formattedHours = formatTimes(tradingHoursWithDefaults, centreTimeZone);
  const groupedHours = groupOvernightAndMultiple(formattedHours); // We may have partial overnight data

  const MIN_OVERNIGHT_GROUP_LENGTH = 2;
  const filteredGroups = groupedHours.filter(group => group[0].hourStatus !== HourStatus.Overnight || group.length >= MIN_OVERNIGHT_GROUP_LENGTH);
  return parseGroupedHours(filteredGroups, centreTimeZone, isLateNight);
};